import { Label } from '@fluentui/react-northstar/dist/es/components/Label/Label';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './index.module.scss';

import LOGO from '../../static/media/notavailable.svg';



const NotAvailable = () => {

    return (
        <div className={styles.container}>
            <div className={styles.group}>
                <p className={styles.info}>Bigtincan tab is not supported in Group chat. Please navigate to a meeting to configure the tab</p>
                <img src={LOGO} />
            </div>
        </div>
    )
};

export default connect()(NotAvailable);
